<template>
    <div class="activeTrucksWrapper">
      <div class="table-responsive">
       <table class="table-hover orderList" v-if="trucks">
            <thead>
              <tr>
                <th>Status</th>
                <th>Regnr</th>
                <th>Ordernummer</th>
                <th>Chaufför</th>
                <th>Leveransställe</th>
              </tr>
            </thead>
            <tbody>
              <tr class="orderListItem" v-for="(truck) in trucks" :key="truck.id" v-on:click="orderDetails(truck)">
                <td>
                  <span v-if="truck.State">{{ truck.State }}</span>
                  <span v-else>Okänd</span>
                </td>
                <td>{{ truck.Name }}</td>
                <td>{{ setOrderId(truck.Order) }}</td>
                <td>{{ truck.Driver }}</td>
                <td>{{ truck.Destination }}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
</template>
<script>
export default {
  name: 'ActiveTrucks',
  data () {
    return {
    }
  },
  props: {
    trucks: Array
  },
  methods: {
    setOrderId (order) {
      let newId = ''
      if (order.type === 'feralco') {
        newId = order.data.SalesId
      } else if (order.type === 'feralcoIntern') {
        newId = order.data.fraktsedelNr
      } else {
        newId = order.id
      }

      return newId
    },
    async orderDetails (truck) {
      let schema = await this.$http.get('/api/orders/schema/' + truck.OrderType)
      if (truck.OrderType === 'feralco') {
        this.$router.push({ name: 'FeralcoOrdersDetails', params: { id: truck.OrderId, order: truck.Order, schema: schema.data.schema } })
      } else if (truck.OrderType === 'feralcoIntern') {
        this.$router.push({ name: 'FeralcoInternOrderDetails', params: { id: truck.OrderId, order: truck.Order, schema: schema.data.schema } })
      } else {
        this.$router.push({ name: 'OrderDetails', params: { id: truck.OrderId, order: truck.Order, schema: schema.data.schema } })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Map/ActiveTrucks.vue